import { render, staticRenderFns } from "./DocumentTest.vue?vue&type=template&id=5688cdc2"
import script from "./DocumentTest.vue?vue&type=script&lang=js"
export * from "./DocumentTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports